<template>
    <div>
        <tq-table
                class="TQ_bg_white TQ_padding_8px "
                :rows="co_uds_sortQuestPermissions_ac"
                :system-lang-code="p_systemLangCode_e"
                p_td-classes_s="TQ_padding_8px"
                :columns="[
                        {
                            label : ass_strings.oneWord_image[p_systemLangCode_e],
                            avatar_f:(uds_questPermissions_c) =>{
                                 return p_userData_byUserId_c[uds_questPermissions_c.udsqp_userId_uid]!= null ? p_userData_byUserId_c[uds_questPermissions_c.udsqp_userId_uid].ud_avatar_c : null
                            },
                            defaultImg_f: () => { return ass_img_user_b},
                        },
                        {
                           label : ass_strings.oneWord_name[p_systemLangCode_e],
                           field : (uds_questPermissions_c) =>{
                                return p_userData_byUserId_c[uds_questPermissions_c.udsqp_userId_uid]!= null ? p_userData_byUserId_c[uds_questPermissions_c.udsqp_userId_uid].ud_name_s : ass_strings.oneWord_loading[p_systemLangCode_e] + '...'
                           }
                        },
                         {
                           label : ass_strings.oneWord_permissions[p_systemLangCode_e],
                           field : (uds_questPermissions_c) =>{
                                return str_capitalizeFirstLetter_s(format_questPermission_s(uds_questPermissions_c.udsqp_permission_n, p_systemLangCode_e))
                           }
                        },
                        ]"

                :p_actions_ao="[
                    {display : (uds_questPermissions_c) => this.co_currentUser_haveOwnerPermissions_b && !this.m_ownerPermission_b(uds_questPermissions_c) ,     label_byLangCode : ass_strings.oneWord_edit,    action_f : m_clickQuestRow_f,   class : 'TQ_bg_gold'},
                    {display : (uds_questPermissions_c) => this.m_currentUser_b(uds_questPermissions_c) && !this.m_ownerPermission_b(uds_questPermissions_c),   label_byLangCode : ass_strings.oneWord_remove,    action_f : m_showRemoveUserPopup_f,   class : 'TQ_bg_red'},
                ]"
        />
        <hr>
        <div v-if="co_currentUser_haveOwnerPermissions_b">
            <div class="TQ_padding_8px TQ_bg_purple TQ_inline TQ_borderRadius TQ_text_20px TQ_box_shadow TQ_clickable"
                 @click="m_clickAddNewUser_f">
                {{ass_strings.fourWords_accessToNewUser[p_systemLangCode_e]}}
            </div>
        </div>

        <!-- add new user -->
        <tq-popup :show="showPopup_vb" width="100%"  maxWidth="450px" class="TQ_center" padding="0px" :show-close-btn="true" >
            <div class="TQ_text_32px TQ_bg_purple TQ_borderRadius_top TQ_padding_8px">
                {{ass_strings.twoWords_userAccess[p_systemLangCode_e]}}
            </div>

            <div class="TQ_padding_16px_0px">

                <!-- user info -->
                <div>
                    <input class="TQ_verticalAlignMiddle TQ_padding_4px TQ_margin_4px TQ_text_20px TQ_width_100p TQ_maxWidth_350px TQ_borderBox TQ_center"
                           disabled
                           v-if="questUserPermissionPopup_o.username_s"
                           v-model="questUserPermissionPopup_o.username_s"/>


                    <div class="TQ_inline TQ_width_100p TQ_maxWidth_350px TQ_margin_4px">
                        <tq-on-top-container class="TQ_inline ">
                            <input slot="body"
                                   :placeholder="ass_strings.oneWord_email[p_systemLangCode_e]"
                                   v-model="questUserPermissionPopup_o.email_s"
                                   @change="m_searchUser_f"
                                   :disabled="showSearchUserLoader_b || questUserPermissionPopup_o.userId_uid !== ''"
                                   class="TQ_verticalAlignMiddle TQ_padding_4px TQ_text_20px TQ_width_100p TQ_borderBox TQ_center TQ_direction_ltr"/>
                            <tq-loader-container :p_show-loader_b="showSearchUserLoader_b"
                                                 v-if="questUserPermissionPopup_o.email_s !== ''"
                                                 :slot="helper_getDirectionByLangCode_fe(p_systemLangCode_e) === enum_directions.rtl ? 'middleLeft' : 'middleRight'">
                                <tq-image v-if="questUserPermissionPopup_o.userId_uid"
                                          @click.native="m_clearSearch"
                                          :pb_src_r="ass_img_xLetter_b"
                                          class="TQ_width_20px TQ_verticalAlignMiddle TQ_clickable TQ_margin_2px"/>
                                <tq-image v-else
                                          @click="m_searchUser_f"
                                          :pb_src_r="ass_img_searchEmpty_b"
                                          class="TQ_width_20px TQ_verticalAlignMiddle TQ_clickable TQ_margin_2px"/>
                            </tq-loader-container>
                        </tq-on-top-container>
                    </div>

                </div>

                <!-- user access level -->
                <tq-dropdown class=" TQ_width_100p TQ_maxWidth_350px TQ_margin_4px" :style-select="true" :ps_only-mobile-mode_b="true">

                    <div slot="select" class="TQ_padding_4px">
                        {{format_questPermission_s(questUserPermissionPopup_o.permission_n, p_systemLangCode_e)}}
                    </div>
                    <div slot="options" v-for="questPermission_n in co_availableUsersLevel_ae"
                         @click="questUserPermissionPopup_o.permission_n = questPermission_n">
                        {{format_questPermission_s(questPermission_n, p_systemLangCode_e)}}
                    </div>
                </tq-dropdown>

            </div>

            <div class="TQ_padding_16px_0px"></div>

            <hr >

            <!-- buttons -->
            <div class="TQ_grid_col_Auto1frAuto TQ_margin_bottom_8px TQ_margin_0_8px">
                <div class="TQ_padding_8px TQ_bg_red TQ_inline TQ_borderRadius TQ_box_shadow TQ_clickable"
                    @click="showPopup_vb.val=false">
                    {{ass_strings.oneWord_cancel[p_systemLangCode_e]}}
                </div>
                <div></div>
                <tq-loader-button :show-loader="showBtnLoader_b">
                    <div class="TQ_padding_8px TQ_bg_green TQ_inline TQ_borderRadius TQ_box_shadow TQ_clickable"
                         v-if="questUserPermissionPopup_o.userId_uid"
                         @click="m_addNewUser_f">
                        {{ass_strings.oneWord_approve[p_systemLangCode_e]}}
                    </div>
                </tq-loader-button>

            </div>


        </tq-popup>

        <!-- remove user -->
        <tq-popup :show="showPopup_removeUser_vb" width="100%"  maxWidth="450px" class="TQ_center" padding="0px" :show-close-btn="true" >
            <div class="TQ_bg_purple_dark TQ_padding_8px TQ_text_24px">
                {{ass_strings.oneWord_warning[p_systemLangCode_e]}}
            </div>
            <div class="TQ_padding_16px TQ_border_bottom_gray TQ_text_20px">
                {{ass_strings.question_removeUser[p_systemLangCode_e]}}
            </div>
            <div class="TQ_padding_8px TQ_align_end">
                <tq-loader-container :p_show-loader_b="showBtnLoader_removeUser_b">
                    <div class="TQ_inline TQ_borderRadius TQ_box_shadow TQ_clickable TQ_padding_8px TQ_bg_purple"
                         @click="m_removeUser_f">
                        {{ass_strings.oneWord_approve[p_systemLangCode_e]}}
                    </div>

                </tq-loader-container>

            </div>
        </tq-popup>

    </div>
</template>

<script>
    import TqTable from "../../../../components/basic2/TqTable";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        enum_directions,
        enum_langCodes, enum_moreInfo_helpersIds_s, enum_moveToOptions,
        enum_questPermission_n
    } from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {validator_enum_fb, validator_arrayClass_fb, validator_objClass_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {format_questPermission_s} from "../../../../../functions/src/shareCode/Share_S_Format";
    import {FB_UserDataSub_QuestPermission, FB_UserData} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {ass_img_searchEmpty_b, ass_img_user_b, ass_img_xLetter_b} from "../../../../assets/scripts/Ass_Files";
    import TqMoreInfo from "../../../../components/basic2/TqMoreInfo";
    import TqPopup from "../../../../components/basic/TqPopup";
    import TqLoaderButton from "../../../../components/basic2/TqLoaderButton";
    import TqDropdown from "../../../../components/basic/TqDropdown";
    import TqImage from "../../../../components/basic/TqImage";
    import TqOnTopContainer from "../../../../components/basic/TqOnTopContainer";
    import {helper_getDirectionByLangCode_fe} from "../../../../../functions/src/shareCode/Share_S_Helper";
    import TqLoaderContainer from "../../../../components/basic/TqLoaderContainer";
    import {notification_notify, notification_notify2} from "../../../../scripts/S_Notification";
    import {serverAuth_getOtherUserData_withEmail_fp} from "@/scripts/Server/S_ServerAuth";
    import {serverPre_userDataSub_questPermission_set_f} from "@/scripts/Server/S_ServerPre";
    import {str_capitalizeFirstLetter_s} from "@/scripts/S_str";
    import {route_moveToRoute} from "@/router";
    import {obj_deepCopy_f} from "../../../../../functions/src/shareCode/Share_S_Obj";

    export default {
        name: "c_Creator_EditQuests_Item_permissions",
        components: {
            TqLoaderContainer,
            TqOnTopContainer, TqImage, TqDropdown, TqLoaderButton, TqPopup, TqMoreInfo, TqTable},
        props:{
            p_systemLangCode_e:{
                type: String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_uds_questPermissions_ac:{
                type: Array,
                require: true,
                validator(val){
                    return validator_arrayClass_fb(val, FB_UserDataSub_QuestPermission)
                }
            },
            p_currentUser_uds_questPermission_c:{
                type: FB_UserDataSub_QuestPermission,
                require: true,
            },
            p_userData_byUserId_c :{
                type: Object,
                require: true,
                validator(val){
                    return validator_objClass_fb(val, FB_UserData)
                }
            },
            pe_setQuestPermission_f:{
                type: Function,
                require: true,
            },
        },
        data(){
            return {

                showPopup_vb : {val: false},
                showPopup_removeUser_vb : {val: false},
                btnLoader : null,
                showSearchUserLoader_b : null,
                questUserPermissionPopup_o: {
                    permission_n : 3,
                    email_s : '',
                    username_s : '',
                    userId_uid : '',
                },
                selected_uds_questPermissions_c : null,
                showBtnLoader_b : false,
                showBtnLoader_removeUser_b : false,

                // import
                ass_strings : ass_strings,
                enum_directions : enum_directions,
                enum_moreInfoIds_s : enum_moreInfo_helpersIds_s,
                str_capitalizeFirstLetter_s : str_capitalizeFirstLetter_s,
                helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe,
                ass_img_user_b : ass_img_user_b,
                ass_img_searchEmpty_b : ass_img_searchEmpty_b,
                ass_img_xLetter_b : ass_img_xLetter_b,
                enum_questPermission_n : enum_questPermission_n,
                format_questPermission_s : format_questPermission_s,
            }
        },
        computed:{
            co_currentUser_haveOwnerPermissions_b(){
                return this.p_currentUser_uds_questPermission_c.udsqp_permission_n === enum_questPermission_n.owner
            },
            co_uds_sortQuestPermissions_ac(){
                return this.p_uds_questPermissions_ac.sort((uds_questPermission1_c, uds_questPermission2_c) => {
                    if(this.m_currentUser_b(uds_questPermission1_c)){
                        return -1
                    }
                    if(this.m_currentUser_b(uds_questPermission2_c)){
                        return 1
                    }

                    return uds_questPermission1_c.udsqp_permission_n < uds_questPermission2_c.udsqp_permission_n ? 1 : -1
                })
            },
            co_availableUsersLevel_ae(){
                let ans = obj_deepCopy_f(enum_questPermission_n)
                delete ans.owner
                return ans

            }
        },
        methods:{
            m_clickQuestRow_f(uds_questPermission_c){
                this.showPopup_vb.val=true;

                let userData_c = this.p_userData_byUserId_c[uds_questPermission_c.udsqp_userId_uid]

                this.questUserPermissionPopup_o.email_s = userData_c.ud_email_s
                this.questUserPermissionPopup_o.username_s = userData_c.ud_name_s
                this.questUserPermissionPopup_o.userId_uid = userData_c.ud_userId_uid
                this.questUserPermissionPopup_o.permission_n = uds_questPermission_c.udsqp_permission_n
            },
            m_showRemoveUserPopup_f(uds_questPermissions_c){
                this.selected_uds_questPermissions_c = uds_questPermissions_c
                this.showPopup_removeUser_vb.val = true
            },
            m_removeUser_f(){
                this.showBtnLoader_removeUser_b = true
                this.selected_uds_questPermissions_c.udsqp_permission_n = enum_questPermission_n.none
                this.pe_setQuestPermission_f(this.selected_uds_questPermissions_c.udsqp_userId_uid, this.selected_uds_questPermissions_c.udsqp_permission_n, (uds_questPermission_c) => {
                    this.showBtnLoader_removeUser_b = false
                    route_moveToRoute(enum_moveToOptions.creator_edit_list)
                })

            },
            m_clickAddNewUser_f(){
                this.showPopup_vb.val=true;
                this.m_clearSearch()
            },
            m_clearSearch(){
                this.questUserPermissionPopup_o.userId_uid = ''
                this.questUserPermissionPopup_o.username_s = ''
                this.questUserPermissionPopup_o.email_s = ''
            },
            m_searchUser_f(){
                this.showSearchUserLoader_b = true
                this.questUserPermissionPopup_o.email_s = this.questUserPermissionPopup_o.email_s.toLowerCase()

                serverAuth_getOtherUserData_withEmail_fp(this.questUserPermissionPopup_o.email_s)
                    .then((userData_c) => {
                        this.showSearchUserLoader_b = false
                        if(userData_c){
                            this.questUserPermissionPopup_o.userId_uid = userData_c.ud_userId_uid
                            this.questUserPermissionPopup_o.username_s = userData_c.ud_name_s

                            this.$set(this.p_userData_byUserId_c, userData_c.ud_userId_uid, userData_c)

                        }else{
                            notification_notify2({title_s : ass_strings.oneWord_error[this.p_systemLangCode_e], text_s: ass_strings.threeWords_userNotExist[this.p_systemLangCode_e]})
                        }
                    })
                    .catch((err)=>{
                        this.showSearchUserLoader_b = false
                    })
            },
            m_addNewUser_f(){

                this.showBtnLoader_b = true
                this.pe_setQuestPermission_f(this.questUserPermissionPopup_o.userId_uid, this.questUserPermissionPopup_o.permission_n, (uds_questPermission_c) => {

                    if(uds_questPermission_c == null){
                        this.showBtnLoader_b = false
                    }else{
                        this.showBtnLoader_b = false
                        this.showPopup_vb.val = false
                    }
                })
            },
            m_currentUser_b(uds_questPermissions_c){
                 return uds_questPermissions_c.udsqp_userId_uid === this.p_currentUser_uds_questPermission_c.udsqp_userId_uid
            },
            m_ownerPermission_b(uds_questPermissions_c){
                return uds_questPermissions_c.udsqp_permission_n === enum_questPermission_n.owner
            },
        },

    }
</script>

<style scoped>

</style>